import { render, staticRenderFns } from "./base-checkbox.vue?vue&type=template&id=5539834e&scoped=true"
import script from "./base-checkbox.vue?vue&type=script&lang=ts"
export * from "./base-checkbox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5539834e",
  null
  
)

export default component.exports